import actions from './actions'

export default function TechnicianDailyRecordsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TECHNICIANDAILYRECORD:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TECHNICIANDAILYRECORD:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TECHNICIANDAILYRECORD:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TECHNICIANDAILYRECORD:
      return {
        ...state,
        editing: { technicianDailyRecordID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TECHNICIANDAILYRECORD_RECIEVED ||
      actions.UPDATE_TECHNICIANDAILYRECORD_RECIEVED ||
      actions.DELETE_TECHNICIANDAILYRECORD_RECIEVED:
      return {
        ...state,
        editing: { technicianDailyRecordID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
